/* =========================================================================
   OfficeLicense24 – der Preis in drei Teilen
   ------------------------------------------------------------------------
   WOFUER: €14,99 steht als eine Zahl da, obwohl nur die 14 die Frage
   beantwortet. Zerlegt man sie - Zeichen klein und hochgestellt, ganze
   Euro gross, Cent klein und hochgestellt - liest man den Preis in
   einem Blick statt in einem Zug. Das Aussehen dazu steht in
   ol-preisschild.css; ohne dieses Skript bleibt der Preis eine normale
   Zahl, nur eben ohne den Kniff.

   ES WIRD NICHTS NEU FORMATIERT.
   Der Text kommt von Shopify (`money`-Filter) und bleibt Zeichen fuer
   Zeichen derselbe - er wird nur an zwei Stellen aufgeteilt. Deshalb
   stimmt er weiter in jeder Waehrung und jedem Land des Shops:

     €14,99      Zeichen vorn, Komma als Trenner
     14,99 €     Zeichen hinten, mit geschuetztem Leerzeichen
     $1,234.56   Punkt als Trenner, Tausenderkomma
     ₺14,99      anderes Zeichen, gleiche Form

   Erkannt wird: alles vor der ersten Ziffer ist das Zeichen, alles ab
   der letzten Ziffer ebenso, und was dazwischen mit Komma-oder-Punkt
   plus GENAU zwei Ziffern endet, sind die Cent. Passt ein Preis nicht
   in dieses Muster ("ab 14,99", "Gratis"), laesst das Skript ihn in
   Ruhe - lieber unveraendert als falsch zerschnitten.

   Vorgelesen wird weiter „vierzehn Komma neun neun“: der Textinhalt
   aendert sich nicht, es kommen nur drei Huellen darum.

   WARUM ALS SKRIPT: die beiden Abschnitte, die Preise zeichnen
   (bsfa-vergleich.liquid 55 KB, bsfa-kat-raster.liquid 22 KB), lassen
   sich mit dem Werkzeug, mit dem dieses Theme gepflegt wird, nicht
   mehr am Stueck schreiben. Zieht der Preis eines Tages in ein
   kleineres Blatt um, gehoeren diese drei Huellen direkt ins Markup
   und diese Datei kann weg.
   ========================================================================= */
(function () {
  'use strict';

  var ZIELE = '.ol-vgl__preis, .bsfa-kat__preis';

  /* Zeichen vorn | Zahl (endet auf einer Ziffer) | Zeichen hinten.
     In der Mitte sind Leerzeichen erlaubt, auch die geschuetzten und
     schmalen, die manche Sprachen als Tausendertrenner setzen. */
  var MUSTER = /^([^0-9]*)([0-9][0-9\s.,  ']*[0-9]|[0-9])([^0-9]*)$/;
  var CENT = /^([\s\S]*[0-9])([.,][0-9]{2})$/;

  function huelle(klasse, text) {
    var s = document.createElement('span');
    s.className = klasse;
    s.textContent = text;
    return s;
  }

  function zerlegen(feld) {
    if (feld.dataset.olPreis) return;

    var text = (feld.textContent || '').trim();
    var teile = text.match(MUSTER);
    if (!teile) return;

    var cent = teile[2].match(CENT);
    var ganz = cent ? cent[1] : teile[2];
    var rest = cent ? cent[2] : '';
    if (!ganz) return;

    feld.dataset.olPreis = '1';

    var zahl = document.createElement('span');
    zahl.className = 'ol-preis__zahl';
    if (teile[1]) zahl.appendChild(huelle('ol-preis__w', teile[1]));
    zahl.appendChild(document.createTextNode(ganz));
    if (rest) zahl.appendChild(huelle('ol-preis__c', rest));
    if (teile[3]) zahl.appendChild(huelle('ol-preis__w', teile[3]));

    feld.textContent = '';
    feld.appendChild(zahl);
  }

  function los() {
    Array.prototype.forEach.call(document.querySelectorAll(ZIELE), zerlegen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else {
    los();
  }
})();
